import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=33636b2d&scoped=true&"
import script from "./repair.vue?vue&type=script&lang=ts&"
export * from "./repair.vue?vue&type=script&lang=ts&"
import style0 from "./repair.vue?vue&type=style&index=0&id=33636b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33636b2d",
  null
  
)

export default component.exports